/**
 * True only when the token grants WORKER access and neither workplace nor
 * employee access. A dual-typed account (e.g. `worker,workplace_user`) is a
 * legitimate workplace user and must NOT be short-circuited.
 *
 * Reads the same comma-separated `custom:user_types` attribute as
 * `isEmployeeToken`; values are `UserType` enum names with inconsistent
 * casing, so we lower-case before comparing. See `initCognitoSession` for why
 * worker-only tokens are short-circuited before hydration (ET-1285).
 */
export function isWorkerToken(userTypesAttribute: unknown): boolean {
  if (typeof userTypesAttribute !== "string") {
    return false;
  }
  const userTypes = userTypesAttribute.split(",").map((type) => type.trim().toLowerCase());
  return (
    userTypes.includes("worker") &&
    !userTypes.includes("employee") &&
    !userTypes.includes("workplace_user")
  );
}
